import React from "react";
import { Gallery } from "../components/index";
const GalleryPage = () => {
  return (
    <div className="App">
      <Gallery />
    </div>
  );
};

export default GalleryPage;
